import { useMutation } from '@apollo/client/react';
import { useCallback, useEffect, useState } from 'react';

import {
  GetPatientProfileMedixsPatientDocument,
  ReceptionPanePatientFragment,
  UnidentifyMedixsPatientDocument,
} from '~/graphql/generated/graphql';

type Props = {
  patient: ReceptionPanePatientFragment | undefined | null;
};

export const useUnlinkMedixsPatient = ({ patient }: Props) => {
  const [error, setError] = useState<Error | null>(null);
  const [unidentifyMedixsPatient, { loading, error: unlinkError }] = useMutation(
    UnidentifyMedixsPatientDocument,
    {
      refetchQueries: [
        { query: GetPatientProfileMedixsPatientDocument, variables: { patientId: patient?.id } },
      ],
    },
  );
  const handleUnlink = useCallback(() => {
    if (patient?.medixsPatient) {
      unidentifyMedixsPatient({
        variables: {
          input: {
            medixsPatientId: patient.medixsPatient?.id,
          },
        },
      });
    }
  }, [unidentifyMedixsPatient, patient?.medixsPatient]);

  useEffect(() => {
    if (unlinkError) {
      setError(unlinkError);
    }
  }, [unlinkError]);

  return { handleUnlink, loading, error };
};
